import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const route: VueRoute = {
  path: "/addresses/:slug?",
  action: async ({ pathname }) => {
    const c = await import("./views/addresses.vue");
    return h(c.default, { id: pathname.groups.slug });
  },
};

export default route;
